"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.default = {
    e400: {
        title: "This page is not working.",
        subTitle: (React.createElement(React.Fragment, null,
            "The browser sent a request that the server does not understand. If the problem persists, report this error to",
            " ",
            React.createElement("a", { href: "mailto:support@iqmetrix.com" }, "support@iqmetrix.com"),
            ".")),
        btn: "Go Back",
    },
    e403: {
        title: "You do not have permission to view this page.",
        subTitle: "Contact your systems administrator to request permission.",
        btn: "Go to Home",
    },
    e404: {
        title: "This page does not exist.",
        subTitle: (React.createElement(React.Fragment, null,
            "Check the address and try again. If the problem persists, report this error to",
            " ",
            React.createElement("a", { href: "mailto:support@iqmetrix.com" }, "support@iqmetrix.com"),
            ".")),
        btn: "Go Back",
    },
    e405: {
        title: "There is an error with this request.",
        subTitle: (React.createElement(React.Fragment, null,
            "Ensure the sent data is valid and try again. If the problem persists, report this error to",
            " ",
            React.createElement("a", { href: "mailto:support@iqmetrix.com" }, "support@iqmetrix.com"),
            ".")),
        btn: "",
    },
    e408: {
        title: "Our servers have encountered a timeout.",
        subTitle: (React.createElement(React.Fragment, null,
            "Please try again. If the problem persists, report this error to",
            " ",
            React.createElement("a", { href: "mailto:support@iqmetrix.com" }, "support@iqmetrix.com"),
            ".")),
        btn: "",
    },
    e500: {
        title: "A technical issue has occurred.",
        subTitle: (React.createElement(React.Fragment, null,
            "Unsaved information may be lost. Please reload the page and try again. If the problem persists, report this error to ",
            React.createElement("a", { href: "mailto:support@iqmetrix.com" }, "support@iqmetrix.com"),
            ".")),
        btn: "Reload page",
    },
    e599: {
        title: "This page lost internet connection.",
        subTitle: (React.createElement(React.Fragment, null,
            "Check your Wi-Fi or local network connection and try again. If the problem persists, report this error to",
            " ",
            React.createElement("a", { href: "mailto:support@iqmetrix.com" }, "support@iqmetrix.com"),
            ".")),
        btn: "Reload page",
    },
    custom: {
        title: "Oops! Something is wrong with your request. Check the error and try again.",
        subTitle: "",
        btn: "",
    },
};
//# sourceMappingURL=en.js.map